let activeMenuItem = null;

// Handle click
function handleClickEvent(event) {
  const eventItem = event.target.closest('.nav-item-text');
  const linkItem = event.target.closest('a.nav-link');
  if (!eventItem) {
    return;
  }

  if (linkItem) {
    event.preventDefault();
    // Navigate to the link
    window.location.href = linkItem.getAttribute('href');
    return;
  }

  if (eventItem === activeMenuItem) {
    // Close submenu that is currently active
    closeAllOtherItems(null);
    activeMenuItem = null;
    return;
  }

  // Open the submenu for the newly clicked item
  closeAllOtherItems(eventItem);
  openSpecificItem(eventItem);
}

// Handle mouseenter and focus events
function handleMouseEnterandFocusEvent(event) {
  const eventItem = event.target.closest('.nav-item-text');
  if (eventItem) {
    closeAllOtherItems(eventItem);
    openSpecificItem(eventItem);
  }
}

// Handle focusout and mouseleave events
function handleFocusOutandMouseLeaveEvent(event) {
  // Check if focus is moving outside the navigation menu structure
  const nav = document.querySelector('.nav-menu');
  if (!nav.contains(event.relatedTarget)) {
    // Close all submenus
    closeAllOtherItems(null);
    activeMenuItem = null;
  }
}

// Close all other items except the one passed as an argument
function closeAllOtherItems(exceptItem) {
  const nav = document.querySelector('.nav-menu');
  const items = nav.querySelectorAll('.nav-item-text');
  items.forEach((item) => {
    if (item !== exceptItem) {
      item.classList.remove('active');
    }
  });
}

// Open the specific item passed as an argument
function openSpecificItem(item) {
  item.classList.add('active');
  activeMenuItem = item;
}

// Handle keyboard event for .nav-item-text elements
function handleKeyDownEnterEvent(event) {
  if (event.key === 'Enter') {
    handleClickEvent(event);
  }
}

export const _events = {
  handleClickEvent,
  handleKeyDownEnterEvent,
  handleMouseEnterandFocusEvent,
  handleFocusOutandMouseLeaveEvent
};

function mastheadEvents() {
  const nav = document.querySelector('.nav-menu');
  const navItemTexts = document.querySelectorAll('.nav-item-text');
  navItemTexts.forEach((item) => {
    item.setAttribute('tabindex', '0');
  });

  if (!nav) {
    return;
  }

  nav.addEventListener('click', _events.handleClickEvent);
  nav.addEventListener('mouseenter', _events.handleMouseEnterandFocusEvent, true);
  nav.addEventListener('focusin', _events.handleMouseEnterandFocusEvent, true);
  nav.addEventListener('focusout', _events.handleFocusOutandMouseLeaveEvent, true);
  nav.addEventListener('mouseleave', _events.handleFocusOutandMouseLeaveEvent, true);
  navItemTexts.forEach((item) => {
    item.addEventListener('keydown', _events.handleKeyDownEnterEvent);
  });
}

export default mastheadEvents;
